<template>
  <div class="setpassword">
    <Head :title="title"></Head>
    <div class="setpassword_content">
      <div
        style="
          font-size: 23px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          margin-top: 100px;
          margin-left: 30px;
        "
      >
        设置新密码
      </div>
      <div style="margin-top: 30px; padding: 0px 20px 0px 14px">
        <van-form ref="passForm">
          <van-field
            style="border-bottom: 1px solid #eeeeee"
            v-model="password"
            name="password"
            type="password"
            placeholder="请输入密码"
            :rules="telRules"
          >
          </van-field>
        </van-form>
      </div>
      <div
        style="
          font-size: 13px;
          font-weight: 400;
          color: #999999;
          font-family: PingFangSC-Regular, PingFa;
          margin-left: 30px;
          margin-top: 10px;
        "
      >
        密码至少6位,包含数字/字母/字符2种
      </div>
    </div>
    <div class="exit">
      <van-button class="bot" @click="affirm">确认更换</van-button>
    </div>
  </div>
</template>

<script>
import Head from "../components/headTabs.vue";
import { Toast } from "vant";
export default {
  name: "setpassword",
  components: {
    Head,
  },
  data() {
    return {
      title: "更换手机号",
      password: "",
      telRules: [
        {
          required: true,
        },
        {
          min: 6,
          max: 20,
          message: "密码长度为6-20位",
        },
        {
          // 自定义校验规则
          validator: (value) => {
            return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(value);
          },
          message: "密码必须包含数字、字母、字符中的两种",
          trigger: "onBlur",
        },
      ],
    };
  },
  mounted() {
    this.phone = this.$route.query.phone;
    this.code = this.$route.query.code;
  },
  methods: {
    affirm() {
      this.$refs.passForm.validate().then(async () => {
        let obj = {
          mobile: this.phone,
          validateCode: this.code,
          pwd: this.password,
        };
        const res = await this.$apis.userServe.setPhone(obj);
        if (res.resultCode == 200) {
          Toast(res.resultDesc);
          this.$router.push("my");
        } else {
          Toast(res.resultDesc);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.setpassword {
  width: 100vw;
  min-height: 100vh;
  background: #fff;
  overflow: hidden;
  .setpassword_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    .my {
      width: 100px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      margin: 0 auto;
    }
  }
  .setpassword_content {
    width: 94%;
    height: 100%;
    margin: 0 auto;
  }
  .exit {
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 22px;
    .bot {
      width: 84%;
      height: 44px;
      border-radius: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      background: #4a79f1;
    }
  }
}
</style>
